import React, { useEffect, useState } from "react";
import Divider from "../common/Divider";
import axios from "axios";
import TicketIcon from "../../gallery/icons/ticketicon.png";
import EventTicket from "./EventTicket";
import { useDispatch, useSelector } from "react-redux";
import EventLoginModal from "./EventLoginModal";
import { BeatLoader } from "react-spinners";
import SecretTicket from "./SecretTicket";
import { setCart } from "../../app/features/event/eventSlice";
import { Link } from "react-router-dom/cjs/react-router-dom";
import EventGroupTicket from "./EventGroupTicket";
import { updateTimer } from "../../app/features/timer/timerSlice";
import { resetAskTicket } from "../../app/features/user/userSlice";
import LogoMark from "../../gallery/default/logomark.png";

export default function AllTickets({ createBooking }) {
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.event.cart);
  const currentEvent = useSelector((state) => state.event.currentEvent);
  const user = useSelector((state) => state.user.user);

  let subAmount = cart.subAmount;
  let discountAmount = 0.0;

  const items = useSelector((state) => state.event.items);
  const timerDistance = useSelector((state) => state.timer.distance);

  const [unaTickets, setUnaTickets] = useState(null);

  const [couponError, setCouponError] = useState(null);
  const [couponData, setCouponData] = useState({
    coupon_code: "",
    user_id: currentEvent.user_id,
    event_id: currentEvent.id,
    amount: subAmount,
  });

  useEffect(() => {
    if (currentEvent && currentEvent.id === 69 && window.fbq) {
      window.fbq("track", "InitiateCheckout");
      console.log(currentEvent.name + " FB InitiateCheckout event fired");
    }
  }, []);

  const showCoupon = (event) => {
    event.preventDefault();
    const couponContainer = document.getElementById("coupon_container");
    couponContainer.style.display = "block";
    const couponLink = document.getElementById("coupon_link");
    couponLink.style.display = "none";
  };

  const setCoupon = (event) => {
    setCouponData({
      ...couponData,
      user_id: currentEvent.user_id,
      event_id: currentEvent.id,
      amount: cart.subTotal,
      [event.target.name]: event.target.value,
    });
  };

  const handleCoupon = async (event) => {
    event.preventDefault();
    const loader = document.getElementById("couponloader");
    if (couponData.coupon_code === "") {
      setCouponError("Please enter coupon code!");
      setTimeout(() => {
        setCouponError(null);
      }, 5000);
      return;
    } else {
      loader.style.display = "block";

      await axios
        .request({
          method: "GET",
          url: `${process.env.REACT_APP_BASE_URL}/api/sanctum/csrf-cookie`,
        })
        .then(async (sanRep) => {
          await axios
            .request({
              method: "POST",
              url: `${process.env.REACT_APP_BASE_URL}/api/getcoupon`,
              data: couponData,
            })
            .then(function (response) {
              if (response.data.data.discount_type === 1) {
                discountAmount = response.data.data.discount_value;
                subAmount = subAmount - discountAmount;
              } else if (response.data.data.discount_type === 2) {
                discountAmount = (subAmount / 100) * response.data.data.discount_value;
                subAmount = subAmount - discountAmount;
              }
              if (subAmount >= 0) {
                const updateCart = {
                  ...cart,
                  subAmount: subAmount,
                  grandTotal: subAmount + cart.bookingFee,
                  discount_amount: discountAmount,
                  discount_type: response.data.data.discount_type,
                  coupon_id: response.data.data.id,
                };
                dispatch(setCart(updateCart));
                loader.style.display = "none";
                const couponContainer = document.getElementById("coupon_container");
                couponContainer.style.display = "none";
                const couponSuccess = document.getElementById("coupon_success");
                couponSuccess.style.display = "block";
              } else {
                setCouponError("This coupon is not applicable");
                setTimeout(() => {
                  setCouponError(null);
                }, 5000);
                loader.style.display = "none";
              }

              return;
            })
            .catch(function (error) {
              setCouponError(error.response.data.message);
              setTimeout(() => {
                setCouponError(null);
              }, 5000);
              loader.style.display = "none";
              console.error(error);
            });
          loader.style.display = "none";
        });
    }
  };

  const hanldeBooking = async (e) => {
    const button = e.currentTarget;
    const loader = document.getElementById("reserveloader");
    loader.style.display = "block";
    button.classList.remove("btn-ticket-reserve");
    button.classList.add("btn-disabled-ticket-reserve");

    const tickets = Object.values(items).reduce((acc, el) => {
      if (el != null) {
        acc.push({
          ticket_id: el.ticket_id,
          quantity: el.quantity,
        });
      }
      return acc;
    }, []);
    await axios
      .request({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/check_inventory`,
        data: { tickets: tickets },
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      })
      .then(async function (response) {
        var distance = 0;
        if (timerDistance) {
          distance = timerDistance;
        } else {
          const countDownDate = new Date().getTime() + 1000 * 60 * 15;
          const now = new Date().getTime();
          distance = countDownDate - now;
        }
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const formattedTime = minutes + " : " + (seconds < 10 ? "0" + seconds : seconds);
        dispatch(updateTimer({ distance, remainingTime: formattedTime }));
        // to display the ticket section in modal

        if (user) {
          const bookingLoader = document.getElementById("bookingloader");
          bookingLoader.style.display = "block";
          button.classList.remove("btn-ticket-reserve");
          button.classList.add("btn-disabled-ticket-reserve");
          //creating booking
          await createBooking({}, false);

          bookingLoader.style.display = "none";
          button.classList.remove("btn-disabled-ticket-reserve");
          button.classList.add("btn-ticket-reserve");
        }
        dispatch(resetAskTicket());

        loader.style.display = "none";
        button.classList.remove("btn-disabled-ticket-reserve");
        button.classList.add("btn-ticket-reserve");
      })
      .catch(function (response) {
        setUnaTickets(response.response.data.unavailable_items);
        const soldElements = document.querySelectorAll(".sold");
        soldElements.forEach((el) => el.classList.add("d-none"));
        loader.style.display = "none";
        button.classList.remove("btn-disabled-ticket-reserve");
        button.classList.add("btn-ticket-reserve");
        setTimeout(() => {
          setUnaTickets(null);
        }, 10000);
      });
  };

  return (
    <div className="login-container">
      <div className="row">
        <div className="col-12">
          <div className="col-12 d-flex justify-content-center mb-3">
            <img src={LogoMark} alt="Sahi Search" />
          </div>
          <h3 className="login-event-title">{currentEvent.name}</h3>
          <div id="tickets-section" className="event-tickets-container">
            <SecretTicket currentEvent={currentEvent} />
            {currentEvent.tickets.map((element, index) => {
              const today = new Date();
              const ticketExpiry = new Date(element.expiry_date);
              const ticketStartAt = new Date(element.start_date);
              let disable = null;
              if (parseInt(element.quantity) - parseInt(element.sold) <= 0 || ticketExpiry.getTime() < today.getTime() || ticketStartAt.getTime() >= new Date().getTime() || element.available_at_door === 1) {
                disable = "card ticket-card ticket-card-disable position-relative";
              }
              return (
                <div key={index}>
                  <EventTicket key={index} ticket={element} disable={disable} />
                </div>
              );
            })}

            {currentEvent.group_tickets &&
              currentEvent.group_tickets.map((element, index) => {
                const today = new Date();
                const ticketExpiry = new Date(element.expiry_date);
                const ticketStartAt = new Date(element.start_date);
                let disable = null;
                if ((parseInt(element.quantity) - parseInt(element.sold)) / parseInt(element.group_tickets) <= 0 || ticketExpiry.getTime() < today.getTime() || ticketStartAt.getTime() >= new Date().getTime() || element.available_at_door === 1) {
                  disable = "card ticket-card ticket-card-disable position-relative";
                }
                return (
                  <div key={index}>
                    <EventGroupTicket key={index} ticket={element} disable={disable} />
                  </div>
                );
              })}
            {cart.productsCount > 0 && (
              <>
                <div className="ticket-booked-info row text-center">
                  <div className="col-12 ticket-info-count">
                    {cart.productsCount}&nbsp;
                    {cart.productsCount === 1 ? "ticket" : "tickets"}
                  </div>

                  <div className="col-12 ticket-info-inclusive">All ticket prices are inclusive of booking fees</div>
                  <div className="col-12">
                    <h3 className="grand-total">
                      {cart.discount_amount > 0 && <span className="discount-applied-success">£{cart.total.toFixed(2)}</span>}
                      &nbsp; £{cart.grandTotal.toFixed(2)}
                    </h3>
                  </div>
                </div>
                <div className="col-12  mt-3" id="coupon_container" style={{ display: "none" }}>
                  <p className="enter-coupon">Enter your coupon code below</p>
                  <div className="input-group mb-2">
                    <input name="coupon_code" id="coupon_code" type="text" className={`form-control coupon-input ${couponError ? "error-input" : ""}`} placeholder="Enter coupon code" aria-describedby="button-addon1" defaultValue={couponData.coupon_code} onChange={(event) => setCoupon(event)} />
                    <button className="btn btn-outline-secondary btn-small-coupon" type="button" id="button-addon1" onClick={handleCoupon}>
                      Use
                    </button>
                  </div>
                  {couponError && <p className="error-text">{couponError}</p>}
                  <div id="couponloader" className="text-center" style={{ display: "none" }}>
                    <BeatLoader color="#C6153B" />
                  </div>
                </div>
                <p className="coupon-link mt-3" id="coupon_link">
                  <span className="sign-up" onClick={(event) => showCoupon(event)}>
                    Use Coupon Code
                  </span>
                </p>

                <p className="success-text" id="coupon_success" style={{ display: "none" }}>
                  Coupon code applied!
                </p>
                <div
                  className="row"
                  style={{
                    marginTop: "15px",
                    marginBottom: "24px",
                  }}
                >
                  <div className="col-12">
                    <ul className="ticket-info-list">
                      <li>These electronic tickets will be delivered to your email.</li>
                      <li>Tickets purchased are not refundable. If the event gets cancelled, you will receive a refund within 30 days.</li>
                      <li>Coupon codes cannot be stacked.</li>
                    </ul>
                  </div>
                  <Link className="mx-2 ticket-info-learn-more" to="/e-ticket" target="blank">
                    Learn more about e-tickets here
                  </Link>
                </div>
              </>
            )}
            <div className="row">
              <div className="col-12">
                {cart.productsCount > 0 ? (
                  <>
                    {unaTickets &&
                      unaTickets.map((unaTicket, index) => (
                        <p className="sign-up text-center" key={index}>
                          {unaTicket.name} {unaTicket.available_quantity < 1 ? " not available" : " only " + unaTicket.available_quantity + " left"}{" "}
                        </p>
                      ))}

                    <button className="btn btn-ticket-reserve" onClick={hanldeBooking}>
                      <img src={TicketIcon} alt="" />
                      &nbsp;&nbsp;Reserve tickets
                    </button>
                    <div id="reserveloader" className="text-center" style={{ display: "none" }}>
                      <BeatLoader color="#C6153B" />
                    </div>
                    <div id="bookingloader" className="text-center" style={{ display: "none" }}>
                      <BeatLoader color="#C6153B" />
                      <h4 className="mt-3" style={{ color: "#C6153B" }}>
                        Creating Booking...
                      </h4>
                    </div>
                    <EventLoginModal />
                  </>
                ) : (
                  <button className="btn btn-disabled-ticket-reserve">
                    <img src={TicketIcon} alt="" />
                    &nbsp;&nbsp;Reserve tickets
                  </button>
                )}
              </div>
              <div className="col-12 text-center pt-4">
                <Link className="mx-2 pp-tc" to="/privacy" target="blank">
                  View Privacy Policy
                </Link>
                <Link className="mx-2 pp-tc" to="/terms" target="blank">
                  Terms and Conditions
                </Link>
              </div>
              <Divider />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
